import { render } from "./ReceiveRuleDialog.vue?vue&type=template&id=98b4d242&scoped=true"
import script from "./ReceiveRuleDialog.vue?vue&type=script&lang=js"
export * from "./ReceiveRuleDialog.vue?vue&type=script&lang=js"

import "./ReceiveRuleDialog.vue?vue&type=style&index=0&id=98b4d242&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b4d242"]])

export default __exports__